import { useState } from "react";
import Modal from "components/common/Modal";
import {
  ButtonBase,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export const CountModal = ({ title, description, list, listIcon }) => {
  const [modalStatus, setModalStatus] = useState({
    open: false,
    visible: false,
  });

  const toggleModal = () => {
    setModalStatus((v) => ({ ...v, open: !v.open }));
    setTimeout(
      () => setModalStatus((v) => ({ ...v, visible: !v.visible })),
      200
    );
  };

  if (!list?.length) return "-";

  return (
    <>
      <ButtonBase
        sx={{
          textDecoration: "underline",
        }}
        onClick={toggleModal}
      >
        {list?.length}
      </ButtonBase>

      {(modalStatus.visible || modalStatus.open) && (
        <Modal
          data-no-dnd="true"
          setConfirmDialogAction={toggleModal}
          confirmDialogAction={{
            isOpen: modalStatus.open,
            scroll: "paper",
            closeTextButton: "Fechar",
            children: (
              <>
                <span className="modalResendSentEmail">
                  <InfoOutlinedIcon color="primary" fontSize="12px" />
                </span>
                <span
                  style={{
                    marginTop: "15px",
                    paddingRight: 8,
                    fontSize: "17px",
                  }}
                >
                  {title} ({list?.length}
                  ).{" "}
                </span>
              </>
            ),

            title: (
              <span
                style={{
                  fontSize: "14px",
                  opacity: "0.8",
                  fontWeight: "300",
                  color: "#000",
                }}
              >
                {description}
              </span>
            ),
            subTitle: (
              <List sx={{ pt: 0 }}>
                {list?.map((item) => (
                  <ListItem disableGutters key={item} className="listItemRoot">
                    <ListItemAvatar
                      className="listItemAvatar"
                      sx={{ paddingRight: "10px" }}
                    >
                      {listIcon}
                    </ListItemAvatar>
                    <ListItemText
                      primary={item.name || item.title}
                      className="listItemText"
                    />
                  </ListItem>
                ))}
              </List>
            ),
          }}
        />
      )}
    </>
  );
};


